import { createApp } from 'vue'
import options from './HeaderMegaMenu.options'

const selector = '.kb-component--header-mega-menu'

export default function (Store) {
    const element = document.querySelector(selector)
    if (!element || element.hasAttribute('data-v-app')) return

    options.template = element.outerHTML
    createApp(options).use(Store).mount(element)
}
